function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.39965 3.20068L7.48984 6.14688C7.89499 7.24176 8.75823 8.105 9.85311 8.51014L12.7993 9.60034L9.8531 10.6905C8.75823 11.0957 7.89499 11.9589 7.48984 13.0538L6.39965 16L5.30946 13.0538C4.90432 11.9589 4.04108 11.0957 2.9462 10.6905L0 9.60034L2.9462 8.51014C4.04108 8.105 4.90432 7.24176 5.30946 6.14688L6.39965 3.20068Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1074 0L13.5661 1.23954C13.7686 1.78698 14.2002 2.2186 14.7477 2.42117L15.9872 2.87984L14.7477 3.33851C14.2002 3.54109 13.7686 3.97271 13.5661 4.52015L13.1074 5.75969L12.6487 4.52015C12.4461 3.97271 12.0145 3.54109 11.4671 3.33851L10.2275 2.87984L11.4671 2.42117C12.0145 2.2186 12.4461 1.78698 12.6487 1.23954L13.1074 0Z",
  fill: "white"
});

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.e44dcacb.svg";
export { ForwardRef as ReactComponent };